import { jsxs as s, jsx as a } from "react/jsx-runtime";
import { useBreakpoint as c, GenericLink as n, Carousel as d, Breakpoints as l } from "@nextgen-web-framework/all";
import { s as t, C as y } from "../../CardCategory-7dd61805.mjs";
const u = (e) => {
  var r;
  const o = c();
  return /* @__PURE__ */ s(
    "div",
    {
      className: `${t["shop-by-category-wrapper"]} ${e.containerClassName}`,
      "data-testid": "shop-by-category-test-id",
      "data-pod-name": "commerce",
      children: [
        !e.hideHeader && /* @__PURE__ */ a("div", { className: t["shop-by-category-title-info"], children: /* @__PURE__ */ s("div", { className: t["shop-by-category-title-container"], children: [
          /* @__PURE__ */ a("h4", { className: t["shop-by-category-title"], children: e.displayTitle }),
          e.link.text && /* @__PURE__ */ a("div", { className: t["shop-by-category-view-all"], children: /* @__PURE__ */ a(n, { href: e.link.url, forceNative: !1, target: e.link.target, children: e.link.text }) })
        ] }) }),
        /* @__PURE__ */ a("div", { className: t["shop-by-category-carousel-container"], children: /* @__PURE__ */ a(
          d,
          {
            id: "Shop-By-Category-Carousel",
            hideButtons: [l.XS, l.SM].includes(o),
            isTileCarousel: !0,
            children: (r = e.cardCategoryData) == null ? void 0 : r.map((i) => /* @__PURE__ */ a(
              y,
              {
                imagesData: i.imagesData,
                title: i.title,
                cardLinkData: i.cardLinkData
              },
              `${i.title}`
            ))
          }
        ) })
      ]
    }
  );
};
export {
  u as default
};
//# sourceMappingURL=ShopByCategory.js.map
